import amanSajidImage from "@/assets/aman-sajid.png";

export const PhishingFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={amanSajidImage}
          alt="Aman Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "I've analyzed thousands of phishing attempts targeting our clients. The sophisticated ones 
            are nearly indistinguishable from legitimate emails. The only reliable defense is building 
            a verification culture — always verify payment changes, login requests, and urgent asks through 
            a separate channel."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Aman Sajid</p>
            <p className="text-sm text-muted-foreground">Founder, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
